export default __webpack_public_path__ + "static/media/geocreator.f7357169.svg";